import { getDailyBlocksCounts } from './API';

const GetDailyBlockCounts = async (startDate, endDate, accessToken) => {
  try {
    const response = await getDailyBlocksCounts(startDate, endDate, accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    console.log('Error getting data: ', error.message);
    return { success: false, data: 'Error' };
  }
};

export default GetDailyBlockCounts;
